<template>
  <b-container>
    <Breadcrumbs crumbString="Products,Graphic Panels"></Breadcrumbs>
    <b-row>
      <b-col class="col-12 col-md-4 col-lg-4">
        <h2>{{ title }}</h2>
        <div>
          Interprerive GRAPHICS/enviroSIGNS understands the advantages and limitations of the various graphic materials
          that are suitable for interpretive, historical, and commemorative signage.
          <ul>
            <li><router-link :to="{ name: 'trucolor' }">TruCOLOR porcelain enamel signs</router-link></li>
            <li><router-link :to="{ name: 'novalloy' }">Novalloy Metal Micro-imaged signs</router-link></li>
            <li><router-link :to="{ name: 'novalloyplus' }">NOVALLOY+PLUS commemorative plaques</router-link></li>
            <li><router-link :to="{ name: 'fiberlast' }">FiberLAST fiberglass embedded signs</router-link></li>
            <li><router-link :to="{ name: 'durareaders' }">DuraREADER custom high-pressure laminate (CHPL) signs</router-link></li>
            <li><router-link :to="{ name: 'imageloc' }">ImageLOC fused graphics signs</router-link></li>
            <li><router-link :to="{ name: 'composite' }">Digital composite signs</router-link></li>
          </ul>
        </div>
        <div><b-btn @click="createEstimateFromPage">Create an Estimate</b-btn></div>
      </b-col>
      <b-col class="col-12 col-md-8 col-lg-8">
        <b-container class="pods-container">
          <b-row>
            <b-col class="col-12 col-md-5 col-lg-5">
              <b-row>
                <b-col class="col-12 image-pod">
                  <router-link :to="{ name: 'durareaders' }">
                  <div class="img graphic-panels-140-img"
                       v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/graphic-panels/upright-interpretive-sign.jpg') + ')'}"></div>
                  <span>Durareader</span>
                  </router-link>
                </b-col>
              </b-row>
              <b-row>
                <b-col class="col-12 image-pod">
                  <router-link :to="{ name: 'novalloy' }">
                  <div class="img graphic-panels-img"
                       v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/graphic-panels/novalloy-interpretive-sign.jpg') + ')'}"></div>
                  <span>Novalloy</span>
                  </router-link>
                </b-col>
              </b-row>
            </b-col>
            <b-col class="col-12 col-md-7 col-lg-7">
              <b-row>
                <b-col class="col-12 image-pod">
                  <router-link :to="{ name: 'fiberlast' }">
                  <div class="img graphic-panels-img"
                       v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/graphic-panels/low-profile-interpretive-sign.jpg') + ')'}"></div>
                  <span>Fiberlast</span>
                  </router-link>
                </b-col>
              </b-row>
              <b-row>
                <b-col class="col-12 image-pod">
                  <router-link :to="{ name: 'imageloc' }">
                  <div class="img graphic-panels-81-img"
                       v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/graphic-panels/upright-imageLOC-sign.jpg') + ')'}"></div>
                  <span>Imageloc</span>
                  </router-link>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="col-12 col-md-5 col-lg-5 image-pod">
              <router-link :to="{ name: 'composite' }">
              <div class="img graphic-panels-74-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/graphic-panels/digital-composite-interpretive-sign.jpg') + ')'}"></div>
              <span>Digital Composite</span>
              </router-link>
            </b-col>
            <b-col class="col-12 col-md-3 col-lg-3 image-pod">
              <router-link :to="{ name: 'novalloyplus' }">
              <div class="img graphic-panels-127-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/graphic-panels/novalloy-plus-dedication-plaque.jpg') + ')'}"></div>
              <span>Novalloy Plus</span>
              </router-link>
            </b-col>
            <b-col class="col-12 col-md-4 col-lg-4 image-pod">
              <router-link :to="{ name: 'trucolor' }">
              <div class="img graphic-panels-93-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/graphic-panels/porcelain-enamel-interpretive-sign.jpg') + ')'}"></div>
              <span>Trucolor Porcelain</span>
              </router-link>
            </b-col>
          </b-row>
        </b-container>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import Breadcrumbs from '@/components/Breadcrumbs.vue'
  import { createEstimateFromPage } from '@/mixins/createEstimateFromPage'

  export default {
    components: {
      Breadcrumbs
    },
    mixins: [ createEstimateFromPage ],
    data () {
      return {
        title: 'Graphic Panels'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/products/GraphicPanels.vue